/**
 * feat-270 — rendering a rehearsal's criteria rubric as a VALUE.
 *
 * Shared by the queue's diff (`ApprovalItemDiff`) and the editor panel's
 * divergence line (`ApprovedValueLine`), because the rubric must read the same
 * way in both places and `String(array)` reads as `a,b,c` in neither.
 *
 * ⚠ **ORDER IS PART OF THE RUBRIC'S MEANING** (ADR-A §5.1), so the rubric renders
 * as a numbered SEQUENCE and never as a bag. Reordering criteria un-approves —
 * unlike reordering questions, which is free (a stated exception to spec D4).
 * A bulleted or unordered rendering would quietly assert the opposite.
 *
 * This module renders. It does not compare, and it must not start: whether the
 * criteria field changed is `fields[].changed` from the server (ADR-B §2.1), and
 * nothing here may look at the two lists' lengths (AT-26b).
 */

import React from 'react';

/** A criterion arrives as a string, or as a row with the text under one of a few keys. */
export function criterionText(entry: unknown): string {
  if (entry && typeof entry === 'object') {
    const row = entry as Record<string, unknown>;
    const text = row.description ?? row.text ?? row.label ?? row.criterion;
    if (typeof text === 'string') return text;
  }
  return String(entry);
}

export const CriteriaList: React.FC<{ value: readonly unknown[] }> = ({ value }) => (
  <ol className="list-decimal ml-4 space-y-0.5 mt-0.5">
    {value.map((entry, i) => (
      <li key={i}>{criterionText(entry)}</li>
    ))}
  </ol>
);
